import { Logger } from "./logger";
import { LogLevel } from "./logLevel";

export function configureLogger(logLevel?: LogLevel | string): void
{
    let parsedLogLevel: LogLevel;
    switch (logLevel || "")
    {
        case "error":
        case "Error":
        case LogLevel.ERROR:
            parsedLogLevel = LogLevel.ERROR;
            break;
        case "warning":
        case "Warning":
        case LogLevel.WARNING:
            parsedLogLevel = LogLevel.WARNING;
            break;
        case "debug":
        case "Debug":
        case LogLevel.DEBUG:
            parsedLogLevel = LogLevel.DEBUG;
            break;
        case "trace":
        case "Trace":
        case LogLevel.TRACE:
            parsedLogLevel = LogLevel.TRACE;
            break;
        default:
            parsedLogLevel = LogLevel.INFORMATION;
            break;
    }

    Logger.setLogLevel(parsedLogLevel ?? LogLevel.INFORMATION);
}
